<proffeo-ui-dialog
  [title]="dialogData?.oshAnalysis?.id ? ('osh.edit-osh-analysis' | translate) : ('osh.add-osh-analysis' | translate)"
>
  <div class="flex flex-col h-full w-full">
    <div class="flex-grow overflow-auto">
      <div class="flex items-center justify-center flex-col">
        <div class="w-full mb-3">
          <proffeo-ui-textarea
            [formField]="form.workDescription"
            label="osh.work-description"
          />
        </div>
        <div class="w-full mb-3">
          <proffeo-ui-date-picker
            [formField]="form.workStartDate"
            label="osh.work-start-date"
          />
        </div>
        <div class="w-full mb-3">
          <proffeo-label [required]="true">{{ 'osh.work-type' | translate }}</proffeo-label>
          <proffeo-osh-analysis-dictionary-dropdown
            [formField]="form.workType"
            [label]="'osh.add-new-work-type' | translate"
            [dictionaryType]="LookupTpe.WorkType"
            [options]="getWorkTypeDictionary()"
          ></proffeo-osh-analysis-dictionary-dropdown>
        </div>
        <div class="w-full mb-3">
          <proffeo-label [required]="true">{{ 'osh.possible-treat' | translate }}</proffeo-label>
          <proffeo-osh-analysis-dictionary-dropdown
            [formField]="form.workPossibleThreat"
            [label]="'osh.add-new-possible-threat' | translate"
            [dictionaryType]="LookupTpe.WorkPossibleThreat"
            [options]="getWorkPossibleThreatDictionary()"
          ></proffeo-osh-analysis-dictionary-dropdown>
        </div>
        <div class="w-full">
          @for (situation of form.dangerousSituations; track $index; let index = $index) {
            @let risk = riskLevels()[index];
            <div class="flex items-center flex-col border-2 py-3 px-3 w-full mb-2">
              <div class="w-full mb-3">
                <proffeo-label [required]="true">{{ 'osh.possible-treat' | translate }}</proffeo-label>
                <proffeo-osh-analysis-dictionary-dropdown
                  [formField]="situation.possibleThreat"
                  [label]="'osh.add-new-possible-threat' | translate"
                  [dictionaryType]="LookupTpe.PossibleThreat"
                  [options]="getPossibleThreatDictionary()"
                ></proffeo-osh-analysis-dictionary-dropdown>
              </div>
              <p class="font-bold mb-2">{{ 'osh.risk-analysis' | translate }}</p>
              <div class="border-2 py-3 px-3 w-full mb-3">
                <div class="flex w-full mb-3 items-center justify-center">
                  <div class="w-full pr-2">
                    <proffeo-label [required]="true">{{ 'osh.probability' | translate }}</proffeo-label>
                    <proffeo-ui-select
                      [formField]="situation.probability"
                      [options]="probabilities"
                    ></proffeo-ui-select>
                  </div>
                  <div class="w-full pr-2">
                    <proffeo-label [required]="true">{{ 'osh.consequences' | translate }}</proffeo-label>
                    <proffeo-ui-select
                      [formField]="situation.consequences"
                      [options]="consequences"
                    ></proffeo-ui-select>
                  </div>
                  <div>
                    <proffeo-label>{{ 'osh.risk-level' | translate }}</proffeo-label>
                    <div
                      [style.background-color]="risk.primary.color"
                      class="w-12 h-10 flex justify-center items-center"
                    >
                      <span class="font-bold">{{ risk.primary.riskLevel }}</span>
                    </div>
                  </div>
                </div>
                <div
                  [style.background-color]="risk.primary.color + '65'"
                  class="w-full mb-3 px-3 py-3 risk-level-description"
                >
                  <span class="font-bold">{{ risk.primary.description | translate }}</span>
                </div>
              </div>
              <div class="w-full mb-3">
                <proffeo-label [required]="true">{{ 'osh.remedies' | translate }}</proffeo-label>
                <div class="flex items-center w-full">
                  <mat-select
                    (selectionChange)="onRemediesChange(index, $event.value)"
                    (openedChange)="onRemediesOpenedChange(index, $event)"
                    [value]="situation.remedies().value()"
                    [compareWith]="compareFn"
                    [multiple]="true"
                    class="w-full text-proffeo-text items-center justify-center rounded-md border bg-proffeo-surface border-proffeo-overlay-subtle px-3 py-2"
                  >
                    <mat-select-trigger>
                      <div class="flex items-center text-nowrap text-proffeo-text gap-1.5">
                        @for (value of situation.remedies().value(); track value?.id) {
                          {{ value?.value + ', ' }}
                        }
                      </div>
                    </mat-select-trigger>
                    @for (item of getRemediesDictionary(); track item.id) {
                      <mat-option
                        [value]="item"
                        class="w-full"
                      >
                        <div class="flex w-full items-center truncate text-nowrap gap-1.5">
                          {{ item.value }}
                        </div>
                      </mat-option>
                    }
                    <div
                      (click)="$event.stopPropagation()"
                      aria-disabled="true"
                      class="w-full add-option"
                    >
                      <mat-checkbox
                        (change)="onNewRemediesCheckboxChange($event)"
                        (click)="$event.stopPropagation()"
                        [checked]="isNewRemediesDictionaryItem()"
                      >
                        {{ 'osh.osh-add-new-remedies' | translate }}
                      </mat-checkbox>
                      @if (isNewRemediesDictionaryItem()) {
                        <proffeo-ui-input
                          (valueChange)="onNewRemediesDictionaryItemChange($event)"
                          (mousedown)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="addOption()"
                          [value]="newRemediesDictionaryItem()"
                          variant="inline"
                        />
                        <div class="flex justify-end mt-1 mb-2">
                          <button
                            (click)="cancelNewRemediesDictionaryItem(); $event.stopPropagation()"
                            class="button-secondary"
                          >
                            {{ 'osh.osh-analysis-cancel' | translate }}
                          </button>
                          <button
                            (mousedown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation(); addOption()"
                            [disabled]="!newRemediesDictionaryItem().trim()"
                            class="ml-2 button"
                          >
                            {{ 'osh.osh-analysis-save' | translate }}
                          </button>
                        </div>
                      }
                    </div>
                  </mat-select>
                </div>
                @if (situation.remedies().touched() && situation.remedies().errors().length > 0) {
                  <mat-error class="text-sm">{{ situation.remedies().errors()[0].message | translate }}</mat-error>
                }
              </div>
              <p class="font-bold mb-2">{{ 'osh.secondary-risk-analysis' | translate }}</p>
              <div class="border-2 py-3 px-3 w-full mb-3">
                <div class="flex w-full mb-3 items-center justify-center">
                  <div class="w-full pr-2">
                    <proffeo-label [required]="true">{{ 'osh.probability' | translate }}</proffeo-label>
                    <proffeo-ui-select
                      [formField]="situation.secondaryRiskAnalysis.probability"
                      [options]="probabilities"
                    ></proffeo-ui-select>
                  </div>
                  <div class="w-full pr-2">
                    <proffeo-label [required]="true">{{ 'osh.consequences' | translate }}</proffeo-label>
                    <proffeo-ui-select
                      [formField]="situation.secondaryRiskAnalysis.consequences"
                      [options]="consequences"
                    ></proffeo-ui-select>
                  </div>
                  <div>
                    <proffeo-label>{{ 'osh.risk-level' | translate }}</proffeo-label>
                    <div
                      [style.background-color]="risk.secondary.color"
                      class="w-12 h-10 flex justify-center items-center"
                    >
                      <span class="font-bold">{{ risk.secondary.riskLevel }}</span>
                    </div>
                  </div>
                </div>
                <div
                  [style.background-color]="risk.secondary.color + '65'"
                  class="w-full mb-3 px-3 py-3 risk-level-description"
                >
                  <span class="font-bold">{{ risk.secondary.description | translate }}</span>
                </div>
              </div>

              <div class="flex justify-between mb-4 w-full">
                <div class="flex justify-start items-center">
                  <div
                    [style.padding-right]="0"
                    class="flex flex-nowrap justify-center items-center avatars-group-container"
                  >
                    @if (assignedUsers().length > 0) {
                      @for (
                        user of assignedUsers() | slice: 0 : 5;
                        track user.id;
                        let userIndex = $index;
                        let first = $first
                      ) {
                        <div
                          [style.z-index]="assignedUsers().length - userIndex - 1"
                          [style.margin-left]="first ? '0' : '-0.6rem'"
                        >
                          <proffeo-avatar
                            [size]="AvatarSize.SM"
                            [user]="user"
                          />
                        </div>
                      }
                    }
                  </div>

                  @if (assignedUsers().length > 5) {
                    <div class="md:pl-1 text-proffeo-muted">
                      <span>+</span>
                      {{ assignedUsers().length - 5 }}
                    </div>
                  }
                </div>
                <button
                  (click)="assignUsers()"
                  class="button"
                >
                  {{ 'osh.assign-users' | translate }}
                </button>
              </div>
            </div>
          }
          <div class="flex mt-2 mb-3 justify-end">
            <button
              (click)="addNextSituation()"
              class="button"
            >
              {{ 'osh.add-next-situation' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      variant="secondary"
      text="{{ 'close' | translate }}"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="handleSaveClick()"
      [disabled]="form().invalid()"
      variant="primary"
      text="{{ 'save-and-close' | translate }}"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
